import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { ArticleApiService } from '../../libs/api-contract';
import { ArticlesActions } from './articles.actions';

@Injectable()
export class ArticlesEffects {
    private actions$ = inject(Actions);
    private articlesApiService = inject(ArticleApiService);

    getRecommendedArticles$ = createEffect(() =>
        this.actions$.pipe(
            ofType(ArticlesActions.getRecommendedArticles),
            switchMap(() =>
                this.articlesApiService.getRecommendedArticles().pipe(
                    map((response) =>
                        ArticlesActions.getRecommendedArticlesSuccess({
                            articles: response ?? [],
                        }),
                    ),
                    catchError(() =>
                        of(
                            ArticlesActions.getRecommendedArticlesFailure({
                                error: 'Failed to get recommended articles',
                            }),
                        ),
                    ),
                ),
            ),
        ),
    );

    getDistributedArticles$ = createEffect(() =>
        this.actions$.pipe(
            ofType(ArticlesActions.getDistributedArticles),
            switchMap(() =>
                this.articlesApiService.getDistributedArticles().pipe(
                    map((response) =>
                        ArticlesActions.getDistributedArticlesSuccess({
                            articles: response ?? [],
                        }),
                    ),
                    catchError(() =>
                        of(
                            ArticlesActions.getDistributedArticlesFailure({
                                error: 'Failed to get distributed articles',
                            }),
                        ),
                    ),
                ),
            ),
        ),
    );

    getArticle$ = createEffect(() =>
        this.actions$.pipe(
            ofType(ArticlesActions.getArticle),
            switchMap((action) => {
                return this.articlesApiService
                    .getArticle(action.articleId)
                    .pipe(
                        map((article) =>
                            ArticlesActions.getArticleSuccess({
                                articleId: action.articleId,
                                article,
                            }),
                        ),
                        catchError(() =>
                            of(
                                ArticlesActions.getArticleFailure({
                                    error: 'Failed to get article',
                                }),
                            ),
                        ),
                    );
            }),
        ),
    );
}
